export const ActionTypes = {
  REQUEST_SEND_EMAIL: 'harami/email/REQUEST_SEND_EMAIL',
  SUCCESS_SEND_EMAIL: 'harami/email/SUCCESS_SEND_EMAIL',
  ERROR_SEND_EMAIL: 'harami/email/ERROR_SEND_EMAIL',
} as const
